import { Alignment, Classes, Navbar } from '@blueprintjs/core';
import classNames from 'classnames';
import * as React from 'react';
import { Link } from 'react-router-dom';
import {
  Body,
  DesignerLogo,
  Icon as VbIcon,
} from 'vet-bones/design-system/components';

import { ROUTE } from 'src/constants/routes';
import { TEST_IDS } from 'src/constants/testIds';
import { PortalConnectionButton } from 'src/containers/PortalConnectionButton';
import * as copy from 'src/templates/copy';

export const AppNavbar: React.VFC = () => {
  return (
    <Navbar
      className={classNames('sd-app-navbar', Classes.DARK)}
      data-testid={TEST_IDS.appNavbar.container}
    >
      <Navbar.Group align={Alignment.LEFT}>
        <Link
          className={classNames('sd-app-navbar__logo', Classes.NAVBAR_HEADING)}
          data-testid={TEST_IDS.appNavbar.logo}
          to={ROUTE.HOME}
        >
          <VbIcon IconComponent={DesignerLogo} size={28} />
          <Body size="lg">{copy.components.appNavbar.title}</Body>
        </Link>
      </Navbar.Group>
      <Navbar.Group align={Alignment.RIGHT}>
        <PortalConnectionButton />
      </Navbar.Group>
    </Navbar>
  );
};
